import React, { useEffect, Suspense, lazy } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import { db, auth } from "config/firebase";
import { useDispatch, useSelector } from "react-redux";
import { loadEmployees } from "store/employee";
import Navbar from "components/Navbar";
import Snackbar from "@material-ui/core/Snackbar";
import Alert from "@material-ui/lab/Alert";
import "App.css";
import { closeSnackBar } from "store/SnackBar";
import { changeLoggedInStatus } from "store/isLoggedIn";
import { Backdrop, CircularProgress } from "@material-ui/core";
import SignUp from "components/Signup";

const PrivateRoute = ({ children, ...rest }) => {
  const isLoggedIn = useSelector((state) => state.login);
  return (
    <Route
      {...rest}
      render={() => (isLoggedIn ? children : <Redirect to="/signin" />)}
    />
  );
};

const SignIn = lazy(() => import("components/SingIn"));
const HomePage = lazy(() => import("components/HomePage"));
const EmployeePage = lazy(() => import("components/EmployeePage"));

const App = () => {
  const snackBarMessage = useSelector((state) => state.snackBar);
  const isLoggedIn = useSelector((state) => state.login);

  const dispatch = useDispatch();
  useEffect(() => {
    const employee = [];
    const fetchData = async () => {
      try {
        const docs = await db.collection("employee").orderBy("name").get();
        docs.forEach((doc) => employee.push({ id: doc.id, ...doc.data() }));
        dispatch(loadEmployees(employee));
      } catch (error) {
        console.log(error);
      }
    };

    auth.onAuthStateChanged((user) => {
      if (user) fetchData();
      dispatch(changeLoggedInStatus(user ? true : false));
    });
  }, [dispatch]);
  const handleClose = () => dispatch(closeSnackBar());
  return (
    <Suspense
      fallback={
        <Backdrop open={true}>
          <CircularProgress color="primary" />{" "}
        </Backdrop>
      }
    >
      <Router>
        {isLoggedIn && <Navbar></Navbar>}
        <Snackbar
          open={snackBarMessage.open}
          autoHideDuration={6000}
          onClose={handleClose}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
        >
          <Alert
            onClose={handleClose}
            variant="filled"
            elevation={6}
            severity={snackBarMessage.severity}
          >
            {snackBarMessage.message}
          </Alert>
        </Snackbar>
        <Switch>
          <PrivateRoute path="/employee">
            <EmployeePage />
          </PrivateRoute>
          <PrivateRoute exact path="/">
            <HomePage />
          </PrivateRoute>
          <Route path="/signin">
            {isLoggedIn ? <Redirect to="/" /> : <SignIn />}
          </Route>
          <Route path="/register">
            {isLoggedIn ? <Redirect to="/" /> : <SignUp />}
          </Route>
        </Switch>
      </Router>
    </Suspense>
  );
};

export default App;
